import React from 'react';
import { Stack, Text } from '@moda/om';
import { OrderItemReturnPolicy } from '../../../constants';
import { OrderItem, OrderItemStatusGroup } from '../../../hooks/useOrder';

type Props = {
  item: OrderItem;
};

export const RequestReturnNonEligibleReason: React.FC<Props> = ({ item }) => {
  if (item.attributes.returnPolicy === OrderItemReturnPolicy.NotEligibleForReturn)
    return <Text>This item was final sale</Text>;

  if (item.attributes.statusGroup === OrderItemStatusGroup.Open)
    return (
      <Stack space={0} alignItems="center">
        <Text>This item has not been shipped yet</Text>
        <Text>
          {typeof item.attributes.shippingStatus === 'string'
            ? item.attributes.shippingStatus
            : item.attributes.shippingStatus?.reason}
        </Text>
      </Stack>
    );

  if (item.attributes.status === 'return_requested') {
    return <Text>Return request in process already</Text>;
  }

  if (item.attributes.status === 'return_rejected') {
    return <Text>The return request for this item was rejected</Text>;
  }

  if (
    item.attributes.statusGroup === OrderItemStatusGroup.Returned ||
    item.attributes.statusGroup === OrderItemStatusGroup.Refunded
  )
    return <Text>This item was already returned</Text>;

  if (item.attributes.statusGroup === OrderItemStatusGroup.Cancelled)
    return <Text>This item was cancelled</Text>;

  if (item.attributes.isReturnableMessage) {
    return <Text>{item.attributes.isReturnableMessage}</Text>;
  }

  return null;
};
